import GiftingSuccessStep from './GiftingSuccessStep';

export default GiftingSuccessStep;
